import { render } from "./LandscapeView.vue?vue&type=template&id=a924caf2&scoped=true&lang=html"
import script from "./LandscapeView.vue?vue&type=script&lang=js"
export * from "./LandscapeView.vue?vue&type=script&lang=js"

import "./LandscapeView.vue?vue&type=style&index=0&id=a924caf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a924caf2"]])

export default __exports__